import { render, staticRenderFns } from "./WorkingHoursRulesModal.vue?vue&type=template&id=45e73048&lang=pug"
import script from "./WorkingHoursRulesModal.vue?vue&type=script&lang=js"
export * from "./WorkingHoursRulesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports